import useGlobalState from '@components/Hooks/useGlobalState';
import Success from '@Shared/Success';
import React from 'react';

const ForgotPasswordSuccess: React.FC = () => {

  const [store,] = useGlobalState();

  return (store.password_sent) ? (
    <Success>
      <h2>Email Sent</h2>
      <p>A password reset email was sent to the address you provided.  After clicking
        on the enclosed link, you will be prompted to create a new password.</p>
    </Success>
  ) : null;
}

export default ForgotPasswordSuccess;